import account from './en/account';
import damage_report from './en/damage_report';
import validation from './fr/validation';

export default {
  validation,
  damage_report,
  account
};
